import { createAction } from "redux-actions";

export const PAYMENT_LIST = "PAYMENT_LIST";
export const paymentList = createAction(PAYMENT_LIST);

export const PAYMENT_DELETE = "PAYMENT_DELETE";
export const paymentDelete = createAction(PAYMENT_DELETE);

export const PAYMENT_DETAILS = "PAYMENT_DETAILS";
export const paymentDetails = createAction(PAYMENT_DETAILS);
